import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconVacationRenterRectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
    <g clipPath="url(#clip0_5098_130944)">
      <rect width="24" height="24" rx="6" fill="#0C3F6A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7689 5.24023L14.5385 7.72666V6.05816H21.0612V13.867L26.9795 19.1587L25.5386 20.9902L18.8191 14.982V8.44854H16.7807V12.8647L11.8045 8.39724L-1.53541 20.9699L-3.02051 19.179L11.7689 5.24023Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5098_130944">
        <rect width="24" height="24" rx="6" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const IconVacationRenterRectangle = forwardRef(_IconVacationRenterRectangle)
